import { postAxios } from "./axiosActions";

export const updateScreenSize = (screenSize) => {
    // URL encode the screen size to handle special characters like *
    const encodedScreenSize = encodeURIComponent(screenSize);
    const url = 'api/Connection/UpdateScreenSize/' + encodedScreenSize;
    const params = { "screenSize": screenSize, callTime: new Date() };
    const request = postAxios(url, { params: params } );
    return {
        payload: request
    };
};
